import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import SummaryCard from "components/SummaryCard/SummaryCard";

const ViewCandidateTimeLine = () => {
  const { candidateId } = useParams();
  const navigate = useNavigate();

  const candidatesData = [
    {
      Stage: "Candidate Submitted",
      Status: "Received",
      SubmitedOn: "23-01-2025",
      FeedbackRemarks: "Resume uploaded by vendor",
      ActionTakenBy: "Staffing Solutions",
    },
    {
      Stage: "Application Screening",
      Status: "Moved to Screening",
      SubmitedOn: "24-01-2025",
      FeedbackRemarks: "Meets basic skills and experience",
      ActionTakenBy: "HR Team",
    },
    {
      Stage: "Screening Feedback",
      Status: "Selected",
      SubmitedOn: "25-01-2025",
      FeedbackRemarks: "Shortlisted for technical interview",
      ActionTakenBy: "HR Team",
    },
    {
      Stage: "Technical Interview",
      Status: "Scheduled",
      SubmitedOn: "26-01-2025",
      FeedbackRemarks: "Scheduled for 06-Apr, virtual",
      ActionTakenBy: "Recruitment Coordinator",
    },
    {
      Stage: "Technical Interview",
      Status: "Rejected",
      SubmitedOn: "27-01-2025",
      FeedbackRemarks: "Candidate rejected",
      ActionTakenBy: "Tech Panel",
    },
  ];

  // Function to render status with icon, matching ViewCandidateProgress
  const renderStatusWithIcon = (status) => {
    switch (status) {
      case "Received":
      case "Moved to Screening":
      case "Selected":
      case "Scheduled":
        return (
          <span className="d-flex align-items-center">
            <i className="fas fa-check-circle text-success me-2"></i>
            {status}
          </span>
        );
      case "Rejected":
        return (
          <span className="d-flex align-items-center">
            <i className="fas fa-times-circle text-danger me-2"></i>
            {status}
          </span>
        );
      default:
        return <span>{status}</span>;
    }
  };

  return (
    <div className="page-content">
      <PageSubHeader
        heading={"View Candidate Progress"}
        routePath={"Home"}
        pageName={"Candidates / View Candidate Progress"}
      />
      <Container fluid className="px-4 py-5">
        <Row className="px-4">
          <SummaryCard title="Candidate Overview">
            <Row className="m-3 mt-0">
              <Col md={6}>
                <p className="sub1">Candidate Name</p>
                <p className="main1">Riya Sharma</p>
                <p className="sub1">Candidate ID</p>
                <p className="main1">C-001</p>
                <p className="sub1">Job Role</p>
                <p className="main1">Frontend Developer</p>
                <p className="sub1">Job ID</p>
                <p className="main1">JD1023</p>
                <p className="sub1">Department</p>
                <p className="main1">Engineering</p>
              </Col>
              <Col md={6}>
                <p className="sub1">Candidate Email</p>
                <p className="main1">riyasharma@email.com</p>
                <p className="sub1">Candidate Mobile Number</p>
                <p className="main1">90XXXXXXXX</p>
                <p className="sub1">Candidate Profile Submitted On</p>
                <p className="main1">23-01-2025</p>
                <p className="sub1">Company Name</p>
                <p className="main1">Elbert Technology</p>
                <p className="sub1">Resume</p>
                <p className="main1" style={{ color: "#1E9EFB" }}>
                  <i
                    className="fa-solid fa-paperclip me-2"
                    style={{ transform: "rotate(-45deg)" }}
                    title="Attach"
                  ></i>
                  View Resume
                </p>
              </Col>
            </Row>
          </SummaryCard>

          <Row className="ms-2 mt-3">
            <Col>
              <h4 style={{ color: "#222222" }}>Progress Timeline</h4>
            </Col>
          </Row>
          <Row>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table
                    className="table mb-0"
                    style={{
                      border: "1px solid #E5E7EB",
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <thead style={{ backgroundColor: "#F9FAFB" }}>
                      <tr>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Stage
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Status
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Submitted On
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Feedback/Remarks
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Action Taken By
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {candidatesData.map((item, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #E5E7EB" }}
                        >
                          <td style={{ padding: "12px", color: "#111827" }}>
                            {item.Stage}
                          </td>
                          <td style={{ padding: "12px" }}>
                            {renderStatusWithIcon(item.Status)}
                          </td>
                          <td style={{ padding: "12px", color: "#111827" }}>
                            {item.SubmitedOn}
                          </td>
                          <td style={{ padding: "12px", color: "#111827" }}>
                            {item.FeedbackRemarks}
                          </td>
                          <td style={{ padding: "12px", color: "#111827" }}>
                            {item.ActionTakenBy}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default ViewCandidateTimeLine;